import { useSelector, useDispatch } from 'react-redux';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { useAuthN } from '../authN/useAuthN';
import * as notificationsActions from '../redux/actions/notificationsActions.Thunks';

export const useNotificationsLogic = () => {
	dayjs.extend(utc);

	const company = useSelector((state) => state.company);
	const dispatch = useDispatch();

	const { getAccessToken, isInProgress, isAuthenticated } = useAuthN();

	const bannerNotifications = useSelector((state) => state.notifications.banner);
	const toastNotifications = useSelector((state) => state.notifications.toast);
	const refreshNotifications = useSelector((state) => state.notifications.refreshNotifications);

	const createNotification = async (createNotification) => {
		if (isAuthenticated && !isInProgress && company) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					notificationsActions.createNotification(
						atResponse.accessToken,
						company.enterpriseProfileId,
						createNotification
					)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const getNotificationTypes = async () => {
		if (isAuthenticated && !isInProgress && company) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			const notificationTypes = await dispatch(
				notificationsActions.getNotificationTypes(atResponse.accessToken, company.enterpriseProfileId)
			);
			return notificationTypes;
		}
	};

	const getNotifications = async (currentDate) => {
		if (isAuthenticated && !isInProgress && company) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			const notifications = await dispatch(
				notificationsActions.getNotifications(atResponse.accessToken, company.enterpriseProfileId, currentDate)
			);
			return notifications;
		}
	};

	const updateNotification = async (updateNotification) => {
		if (isAuthenticated && !isInProgress && company) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					notificationsActions.updateNotification(
						atResponse.accessToken,
						company.enterpriseProfileId,
						updateNotification
					)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const deleteNotification = async (title, notifyThroughDateUtc) => {
		if (isAuthenticated && !isInProgress && company) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					notificationsActions.deleteNotification(
						atResponse.accessToken,
						company.enterpriseProfileId,
						title,
						notifyThroughDateUtc
					)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const refreshCurrentNotifications = async () => {
		const currentDate = dayjs.utc().format();
		await getNotifications(currentDate);
	};

	const dismissNotification = (notificationId) => {
		dispatch(notificationsActions.dismissNotification(notificationId));
	};

	return {
		createNotification,
		getNotificationTypes,
		getNotifications,
		updateNotification,
		deleteNotification,
		refreshCurrentNotifications,
		dismissNotification,
		refreshNotifications,
		bannerNotifications,
		toastNotifications
	};
};
